/* eslint-disable */
import {createBrowserHistory} from 'history'

function appendBaseName (basename, to, state, callback)  {
	if (typeof to === 'string') {
		to = basename + to;
	}
	if (typeof to === 'object' && to.pathname) {
		to.pathname = basename + to.pathname;
	}
	if (state !== undefined && state.pathname) {
		to.pathname = basename + state.pathname;
	}

	return callback(to, state);
}

function createBrowserHistoryWithBasename(basename = '/') {
	let history = createBrowserHistory();
	history.basename = basename;

	const push = history.push;
	const replace = history.replace;
	history.push = (to, state = undefined) => appendBaseName(basename, to, state, push);
	history.replace = (to, state = undefined) => appendBaseName(basename, to, state, replace);

	return history;
};



let his = '';
if (typeof window !== "undefined") {
	const baseUrl = document.getElementsByTagName('base')[0].href;
	//console.log("baseUrl", baseUrl);
	const withoutProtocol = baseUrl.replace(/http(s)?:\/\//, '');
	//console.log("withoutProtocol", withoutProtocol);
	const path = withoutProtocol.substring(withoutProtocol.indexOf("/"), withoutProtocol.length);
	//console.log("path", path);
	his = createBrowserHistoryWithBasename(path);
} else {
	his = {}
}
export default his
